// extracted by mini-css-extract-plugin
module.exports = {"size-above-mobile":"568","size-above-tablet":"800","size-above-book":"1050"};